/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coinvestments_Senddrafts_Recipientsto3Inputs */

const en_coinvestments_senddrafts_recipientsto3 = /** @type {(inputs: Coinvestments_Senddrafts_Recipientsto3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} to`)
};

/**
* | output |
* | --- |
* | "{count} to" |
*
* @param {Coinvestments_Senddrafts_Recipientsto3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_recipientsto3 = /** @type {((inputs: Coinvestments_Senddrafts_Recipientsto3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Recipientsto3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_recipientsto3(inputs)
});
export { coinvestments_senddrafts_recipientsto3 as "coInvestments_sendDrafts_recipientsTo" }